import React, { useEffect } from 'react';
import { useVFSStore } from '../stores/vfsStore';
import { useTabStore } from '../stores/tabStore';

const SimpleFileTree: React.FC = () => {
  const { files, refresh } = useVFSStore();
  const tabStore = useTabStore();
  
  useEffect(() => {
    refresh();
  }, [refresh]);

  // Extract root level directories and files
  const getRootEntries = () => {
    const entries: { path: string; name: string; isDirectory: boolean }[] = [];
    const seen = new Set<string>();
    
    Object.keys(files).forEach(path => {
      const parts = path.split('/');
      if (parts.length === 2) {
        const name = parts[1];
        if (!seen.has(name)) {
          entries.push({
            path,
            name,
            isDirectory: path.endsWith('/')
          });
          seen.add(name);
        }
      }
    });
    
    return entries;
  };

  const rootEntries = getRootEntries();

  const handleFileClick = (path: string, name: string) => {
    tabStore.openTab({
      id: path,
      path: path,
      title: name,
      content: '' // Placeholder content
    });
  };

  return (
    <div className="bg-gray-800 text-white h-full flex flex-col">
      <div className="font-bold mb-4 px-4 pt-4">Explorer</div>
      <ul className="flex-1 overflow-y-auto px-4">
        {rootEntries.map(entry => (
          <li
            key={entry.path}
            className="py-1 hover:bg-gray-700 cursor-pointer flex items-center"
            onClick={() => handleFileClick(entry.path, entry.name)}
          >
            <span className="w-5 mr-1">
              {entry.isDirectory ? '📁' : '📄'}
            </span>
            <span>{entry.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SimpleFileTree;